function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n    .play-button_svg__play-button_svg__st0{fill-rule:evenodd;clip-rule:evenodd;fill-opacity:0.4}.play-button_svg__play-button_svg__st1{fill:none;stroke:#FFFFFF;stroke-width:3}.play-button_svg__play-button_svg__st2{fill:#FFFFFF}\n  ");

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  className: "play-button_svg__play-button_svg__st0",
  cx: 62,
  cy: 62,
  r: 61.1
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  className: "play-button_svg__play-button_svg__st1",
  cx: 62,
  cy: 62,
  r: 60
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "play-button_svg__play-button_svg__st2",
  d: "M81.1,60L54.3,42.6c-1.6-1.1-3.8,0.1-3.8,2.1v34.6c0,1.9,2.1,3.1,3.8,2.1l26.8-17.3c1.1-0.7,1.5-2.3,0.7-3.4 C81.7,60.4,81.4,60.2,81.1,60L81.1,60z"
});

function SvgPlayButton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 124 124",
    style: {
      enableBackground: "new 0 0 124 124"
    },
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default SvgPlayButton;